module.exports = __webpack_public_path__ + "img/vulcano_grey_ba_list.37f5f3a8.jpg";